import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import client from "../lib/api";
import { Loading, Card, Pill } from "../components/common";
import { AdSlot } from "../components/AdSlot";

export default function StoryPage({ type }) {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { setData(null); client.get(`/stories/${type}/${slug}`).then((r) => setData(r.data)).catch(() => setData(false)); }, [type, slug]);
  if (data === null) return <Loading />;
  if (!data) return <div className="py-20 text-center">Story not found.</div>;
  const { story: s, related } = data;
  return (
    <div className="grid lg:grid-cols-3 gap-8" data-testid="story-page">
      <article className="lg:col-span-2">
        <div className="flex items-center gap-2" data-testid="story-tags">
          <Pill tone="gold">{type}</Pill>
          {s.opinion && <Pill tone="live">Opinion</Pill>}
        </div>
        <h1 className="font-head font-black text-3xl md:text-4xl text-green tracking-tight mt-3 leading-tight">{s.title}</h1>
        <p className="text-sm text-ink/50 mt-2">{s.opinion && <span className="font-semibold text-green">Opinion piece · </span>}By {s.author} · {new Date(s.created_at).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}</p>
        {s.dek && <p className="text-lg text-ink/70 mt-3 font-body leading-relaxed" data-testid="story-dek">{s.dek}</p>}
        {s.hero_image && <figure className="mt-5"><img src={s.hero_image} alt={s.title} className="w-full rounded-sm object-cover max-h-96" /><figcaption className="text-xs text-ink/40 mt-1">Castle Lager PSL · {s.title}</figcaption></figure>}
        <div className="prose max-w-none mt-6 text-ink/90 leading-relaxed text-lg font-body">
          {s.body.split(/\n\n+/).map((p, i) => p.startsWith("## ")
            ? <h2 key={i} className="font-head font-bold text-green text-2xl mt-8 mb-3">{p.slice(3)}</h2>
            : <p key={i} className="mb-4">{p}</p>)}
        </div>
        <div className="my-8"><AdSlot id="editorial.midarticle" height={250} /></div>
      </article>
      <aside className="space-y-6">
        <AdSlot id="editorial.sidebar" height={300} />
        <div>
          <h3 className="font-head font-bold text-green mb-3">Related</h3>
          <Card className="divide-y divide-pslborder">
            {related.map((r) => <Link key={r.id} to={`/${type}/${r.slug}`} className="block p-3 text-sm font-semibold hover:bg-cream hover:text-green">{r.title}</Link>)}
          </Card>
        </div>
      </aside>
    </div>
  );
}
